import { cn } from '@/lib/utils';

/** Skeleton loader (brief : pas de spinner bloquant). */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('skeleton h-4 w-full', className)} {...props} />;
}
